(function () {
  'use strict';

  var PARAM = '_pc';

  // ─── Storefront API config (same store for both domains) ───────────────
  var STOREFRONT_API_URL =
    'https://profeel-life.myshopify.com/api/2024-10/graphql.json';
  var STOREFRONT_ACCESS_TOKEN = 'cc4313635c6dea5ab0bed205c53aa5a8';

  // ─── XOR cipher (symmetric) ───────────────────────────────────────────
  function xorCipher(input, key) {
    var k = key.length > 0 ? key : '/';
    var result = '';
    for (var i = 0; i < input.length; i++) {
      result += String.fromCharCode(
        input.charCodeAt(i) ^ k.charCodeAt(i % k.length),
      );
    }
    return result;
  }

  // ─── Base64url encode/decode ──────────────────────────────────────────
  function toBase64url(str) {
    return btoa(str)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }

  function fromBase64url(str) {
    var padded = str.replace(/-/g, '+').replace(/_/g, '/');
    var pad = padded.length % 4;
    if (pad) padded += '===='.slice(pad);
    return atob(padded);
  }

  // ─── Encrypt / Decrypt ────────────────────────────────────────────────
  function encryptString(value, key) {
    return toBase64url(xorCipher(value, key));
  }

  function decryptString(encrypted, key) {
    try {
      return xorCipher(fromBase64url(encrypted), key);
    } catch (e) {
      return null;
    }
  }

  /**
   * Encrypt cart line items into a URL-safe string.
   * @param {Array<{variant_id: number, quantity: number}>} items - Liquid cart items
   * @param {string} key - Encryption key (pathname)
   * @returns {string} Encrypted base64url string
   */
  function encryptLines(items, key) {
    var compact = items
      .map(function (item) {
        return item.variant_id + ':' + item.quantity;
      })
      .join(',');
    return encryptString(compact, key);
  }

  // ─── Storefront API: fetch cart by GID ────────────────────────────────
  function fetchCartFromStorefrontAPI(cartGid) {
    var query =
      'query cart($id: ID!) { cart(id: $id) { lines(first: 50) { nodes { quantity merchandise { ... on ProductVariant { id } } } } } }';

    return fetch(STOREFRONT_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({query: query, variables: {id: cartGid}}),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (json) {
        if (!json.data || !json.data.cart || !json.data.cart.lines) {
          return null;
        }
        return json.data.cart.lines.nodes
          .map(function (node) {
            var gid = node.merchandise && node.merchandise.id;
            if (!gid) return null;
            var match = gid.match(/ProductVariant\/(\d+)/);
            if (!match) return null;
            return {id: parseInt(match[1], 10), quantity: node.quantity};
          })
          .filter(Boolean);
      });
  }

  // ─── INCOMING — .ch → .life ───────────────────────────────────────────
  // Page loads with _pc param containing an encrypted Storefront API cart GID.
  // Decrypt it, call Storefront API to get cart lines, populate Liquid cart.
  function handleIncomingTransfer() {
    var params = new URLSearchParams(window.location.search);
    var encrypted = params.get(PARAM);
    if (!encrypted) return;

    var pathname = window.location.pathname;
    var cartGid = decryptString(encrypted, pathname);

    if (!cartGid || cartGid.indexOf('gid://shopify/Cart/') !== 0) {
      console.warn('[cart-transfer] Invalid cart GID after decrypt');
      cleanUrl();
      return;
    }

    fetchCartFromStorefrontAPI(cartGid)
      .then(function (items) {
        if (!items || items.length === 0) {
          console.warn('[cart-transfer] No items found in transferred cart');
          cleanUrl();
          return;
        }

        return fetch('/cart/clear.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
        })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({items: items}),
            });
          })
          .then(function () {
            cleanUrl();
            if (
              typeof window.Shopify !== 'undefined' &&
              window.Shopify.onCartUpdate
            ) {
              fetch('/cart.js')
                .then(function (r) {
                  return r.json();
                })
                .then(function (c) {
                  window.Shopify.onCartUpdate(c);
                });
            } else {
              window.location.reload();
            }
          });
      })
      .catch(function (err) {
        console.warn('[cart-transfer] Failed to import cart:', err);
        cleanUrl();
      });
  }

  // ─── Clean URL ────────────────────────────────────────────────────────
  function cleanUrl() {
    var url = new URL(window.location.href);
    url.searchParams.delete(PARAM);
    window.history.replaceState({}, '', url.pathname + url.search);
  }

  // ─── Expose utilities for the Liquid block ────────────────────────────
  window.__cartTransfer = {
    PARAM: PARAM,
    encryptLines: encryptLines,
  };

  // ─── Initialize ───────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleIncomingTransfer);
  } else {
    handleIncomingTransfer();
  }
})();
